/**
 * 垂直移动动画
 */
import fvAnimation from './fvAnimation';

export default class fvVerticalMove extends fvAnimation {
    constructor (shape) {
        super(shape, 'fvVerticalMove');
        this.sizeFunction = AsyncFunction('return ' + this.expression);
        this.bottomLeft = AsyncFunction('return ' + this.bottomLeft);
        this.topRight = AsyncFunction('return ' + this.topRight);
        this.bottomLeftMove = AsyncFunction('return ' + this.bottomLeftMove);
        this.topRightMove = AsyncFunction('return ' + this.topRightMove);
        // 初始化y值保存
        this.y = shape.y;
        this.originalSizeY = shape.originalSize.y;
        // 打组初始化各个组件y保存
        for (let p in this.shape.subObjects) {
            if (this.shape.subObjects[p] && this.shape.subObjects[p].$) {
                this.shape.subObjects[p].y = this.shape.subObjects[p].$.y;
            }
        }
    }

    async run (canvas, value) {
        if (value == false) return;
        let size = await this.executionScript(this.sizeFunction);
        let bottomLeftValue = await this.executionScript(this.bottomLeft);
        let topRightValue = await this.executionScript(this.topRight);
        let bottomLeftMoveValue = await this.executionScript(this.bottomLeftMove);
        let topRightMoveValue = await this.executionScript(this.topRightMove);
        let viewNum = (parseFloat(topRightMoveValue) - parseFloat(bottomLeftMoveValue)) * (size - parseFloat(bottomLeftValue)) / (parseFloat(topRightValue) - parseFloat(bottomLeftValue)) + parseFloat(bottomLeftMoveValue);
        // 点不存在不移动
        if (size === -9999) return;
        if (size <= bottomLeftValue || size <= topRightValue) {
            if (bottomLeftMoveValue < topRightMoveValue) {
                this.shape.translateY = 0 - viewNum;
            } else if (bottomLeftMoveValue == topRightMoveValue) {
                this.shape.translateY = 0;
            } else {
                this.shape.translateY = viewNum;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvVerticalMove.js